import type { Account } from '@/types';

/**
 * Demo accounts. Passwords live here ONLY for the local mock login simulation.
 * They are never written to localStorage / sessionStorage, and will be removed
 * once the real authentication service is connected.
 */
export const mockAccounts: Account[] = [
  {
    id: 'acc-1001',
    laundryName: 'مغسلة لاوندري بوكس - النخيل',
    email: 'laundry@laundrybox.sa',
    phone: '0551234567',
    password: '12345678',
    status: 'approved',
    cityId: 'riyadh',
    district: 'النخيل',
  },
  {
    id: 'acc-1002',
    laundryName: 'مغسلة الصفوة',
    email: 'pending@laundrybox.sa',
    phone: '0559876543',
    password: '12345678',
    status: 'pending',
    cityId: 'jeddah',
    district: 'الروضة',
  },
  {
    id: 'acc-1003',
    laundryName: 'مغسلة البدر',
    email: 'rejected@laundrybox.sa',
    phone: '0533334444',
    password: '12345678',
    status: 'rejected',
    rejectionReason:
      'المستندات المرفوعة غير واضحة. يرجى إعادة تقديم السجل التجاري والهوية بجودة أعلى.',
    cityId: 'dammam',
    district: 'الشاطئ',
  },
];